import type { ISourceDocument, IParsedSourceDocument } from '@/types'

export const parseDocumentName = (
  filename: string
): { name: string; extension: string | null } => {
  if (!filename) return { name: '', extension: null }

  let cleaned = filename
  let extension: string | null = null

  const lastDotIndex = cleaned.lastIndexOf('.')
  if (lastDotIndex !== -1 && lastDotIndex < cleaned.length - 1) {
    extension = cleaned.substring(lastDotIndex + 1).toLowerCase()
    cleaned = cleaned.substring(0, lastDotIndex)
  }

  cleaned = cleaned.replace(/[_-]/g, ' ')
  cleaned = cleaned.replace(/\s+/g, ' ')

  return { name: cleaned.trim(), extension }
}

export const parseSourceDocuments = (
  sources: ISourceDocument[]
): IParsedSourceDocument[] => {
  return sources.map(source => {
    const { name, extension } = parseDocumentName(source.name)
    return {
      ...source,
      originalName: source.name,
      parsedName: name,
      extension,
    }
  })
}

export const isPunctuation = (char: string): boolean => {
  return /[.!?;:]/.test(char)
}

export const truncate = (text: string, maxLength: number): string => {
  if (text.length <= maxLength) return text
  return text.substring(0, maxLength) + '...'
}

export const unescapeJsonString = (text: string): string => {
  return text
    .replace(/\\n/g, '\n')
    .replace(/\\"/g, '"')
    .replace(/\\t/g, '\t')
    .replace(/\\r/g, '\r')
    .replace(/\\\\/g, '\\')
}

export const JSON_ANSWER_START_REGEX = /"answer"\s*:\s*"/
export const JSON_STRING_END_REGEX = /(?<!\\)"(?=\s*[,}])/

export const extractAnswerFromStreamingJson = (
  accumulatedJson: string
): string => {
  try {
    const answerStartMatch = accumulatedJson.match(JSON_ANSWER_START_REGEX)
    if (!answerStartMatch) return ''

    const startIndex = answerStartMatch.index! + answerStartMatch[0].length
    let rawAnswer = accumulatedJson.substring(startIndex)

    const endMatch = rawAnswer.match(JSON_STRING_END_REGEX)
    if (endMatch) {
      rawAnswer = rawAnswer.substring(0, endMatch.index)
    }

    return unescapeJsonString(rawAnswer)
  } catch {
    return ''
  }
}
